<template>
  <div>
    <StoreSwitcher v-if="isAdmin" />
    <CommissionsReportFilter v-model="filter" @filter="loadReport" />
    <CommissionsRanking :report="commissionReport" />
    <CommissionsLogList :report="commissionReport" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import withAsyncAction from '@/mixins/withAsyncAction'
import services from '@/services'
import { formatDate } from '@/helpers/date'
import StoreSwitcher from '@/components/Stores/StoreSwitcher'
import CommissionsReportFilter from './CommissionsReportFilter'
import CommissionsRanking from './CommissionsRanking'
import CommissionsLogList from './CommissionsLogList'

const startOfCurrentMonth = () => {
  const now = new Date()
  return formatDate(new Date(now.getFullYear(), now.getMonth(), 1))
}

export default {
  name: 'CommissionsReport',
  components: {
    CommissionsReportFilter,
    CommissionsRanking,
    CommissionsLogList,
    StoreSwitcher
  },
  mixins: [
    withAsyncAction({
      key: 'commissionReport',
      initialState: { logs: [], summary: [] },
      fetcher: {
        methodName: 'fetchCommissionsReport',
        handler: services.reports.fetchCommissionsReport
      }
    })
  ],
  data() {
    return {
      filter: {
        fromDate: startOfCurrentMonth(),
        toDate: formatDate(new Date())
      }
    }
  },
  computed: {
    ...mapGetters('store', ['currentStoreId', 'isAdmin'])
  },
  watch: {
    currentStoreId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadReport()
      }
    }
  },
  created() {
    this.loadReport()
  },
  methods: {
    async loadReport() {
      const storeId = this.currentStoreId
      if (!storeId) return

      const { fromDate, toDate } = this.filter
      try {
        await this.fetchCommissionsReport({ storeId, fromDate, toDate })
      } catch (error) {
        // erros sao exibidos pelo StateRenderer
        console.error('Erro ao carregar relatorio de comissoes', error)
      }
    }
  }
}
</script>
